import { createFileRoute } from "@tanstack/react-router";
import { ContentPage } from "@/components/seo/content-page";
import { pickContent } from "@/assets/generated";
import { seoMeta } from "@/lib/seo/head";
import { legalServiceSchema } from "@/components/seo/json-ld";

export const Route = createFileRoute("/aree/diritto-di-famiglia")({
  head: () => seoMeta({
    title: "AI per il diritto di famiglia",
    description: "Assistente AI per il diritto di famiglia: separazioni consensuali e giudiziali, divorzi, affidamento, successioni.",
    path: "/aree/diritto-di-famiglia",
  }),
  component: () => (
    <ContentPage
      extraSchemas={[legalServiceSchema({ name: "LexAIPro - AI per il diritto di famiglia", description: "Assistenza AI per separazioni, divorzi, affidamento e successioni.", path: "/aree/diritto-di-famiglia" })]}
      eyebrow="Aree di pratica"
      title="LexAIPro per il diritto di famiglia"
      lead="Pratica familiare e successoria: dalla negoziazione assistita ai ricorsi giudiziali, con redazione di accordi e atti."
      breadcrumbs={[{name:"Home",path:"/"},{name:"Aree",path:"/aree/diritto-di-famiglia"},{name:"Diritto di famiglia",path:"/aree/diritto-di-famiglia"}]}
      sections={[
        { heading: "Casi d'uso", bullets: ["Separazioni e divorzi consensuali","Ricorsi al Tribunale per la Famiglia","Accordi di affidamento e mantenimento","Successioni e divisioni ereditarie"] },
      ]}
      cta={{ label: "Prova gratis", to: "/signup" }}
      heroImage={pickContent(27)}
      updated="2026"
    />
  ),
});
